import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconManifold = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M40.096 2.821c-6.58.435-11.748 2.144-14.29 4.727-.924.94-1.485 1.994-1.654 3.108-.11.728-.126 7.096-.02 7.674.293 1.585 2.22 2.18 3.363 1.037.464-.464.601-.863.601-1.755v-.687l.793.392c4.335 2.142 11.198 3.09 17.799 2.457 3.707-.356 7.209-1.252 9.647-2.47.378-.19.702-.344.72-.344s.033 5.473.033 12.163c0 13.914.079 12.33-.65 13.025-.506.483-1 .82-1.782 1.212-2.217 1.114-4.855 1.785-8.441 2.147-1.11.112-1.572.327-1.955.91a2.03 2.03 0 0 0 .745 2.94c.248.133.356.146 1.107.141.458-.003 1.303-.07 1.88-.146 7.305-.978 12.1-3.624 13.006-7.176.076-.297.09-2.781.09-15.968 0-14.763-.006-15.639-.114-16.032-.44-1.61-1.665-3.03-3.631-4.21-3.397-2.038-9.004-3.24-14.942-3.205-.845.005-1.883.032-2.305.06m.256 4.003c-2.516.157-5.169.605-7.168 1.211-2.626.795-4.73 2.092-5.032 3.103-.114.38.058.764.568 1.267 1.823 1.795 6.237 3.129 11.504 3.475 1.402.092 4.872.035 6.112-.1 4.674-.512 8.316-1.695 10.028-3.258.894-.815.943-1.343.2-2.129-1.536-1.624-5.452-2.941-10.26-3.452-.915-.097-4.992-.177-5.952-.117M21.102 22.6a2.07 2.07 0 0 0-1.128.572c-.283.294-15.517 26.183-15.94 27.09-.517 1.102-.727 1.984-.72 3.017.01 1.834.818 3.086 2.868 4.446 2.696 1.789 6.784 2.959 11.898 3.404 1.224.107 5.449.108 6.624.002 3.034-.274 5.475-.74 7.746-1.477 2.82-.916 4.93-2.166 6.105-3.618 1.208-1.493 1.249-3.712.108-5.989C38.14 49 23.088 23.47 22.828 23.188c-.423-.461-1.076-.684-1.725-.587m-6.514 17.507c-4.286 7.284-6.89 11.773-7.028 12.115-.156.387-.22.65-.225.918-.007.374-.005.378.323.68 1.864 1.715 6.212 2.994 11.35 3.337 1.271.084 4.661.045 5.824-.068 4.685-.456 8.62-1.708 10.32-3.284.284-.263.304-.302.304-.6 0-.389-.142-.886-.4-1.398-.148-.295-13.042-22.272-13.549-23.092l-.111-.18z" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconManifold.displayName = 'IconManifold';